export default "__VITE_ASSET__CqFYQTSe__"